export default __webpack_public_path__ + "static/media/fastener-placement-square-rounded-corners.5a131d0a.webp";